import RenderSvg from "../../components/RenderSvg";
import React, { useContext, useEffect } from "react";
import JourneyConfig from "../../context/JourneyConfig";
import Footer from "../../components/Footer";
import { ArrowPathIcon } from "@heroicons/react/16/solid";
import Head from "../Head";
import GoogleIcon from "../../components/GoogleIcon";
function LivenessCheckError({ stepperFunc, onNextStep, color, errorHandlerTexts, config }) {
    const { journey, getJourney } = useContext(JourneyConfig);

  const handleRefresh = async () => {
    sessionStorage.removeItem("error");
    if (!journey) {
      await getJourney(sessionStorage.getItem("jId"));
    }
    stepperFunc(
      sessionStorage.getItem("currentStep")
        ? parseInt(sessionStorage.getItem("currentStep"))
        : 10
    );
  };

  useEffect(() => {
      return () => {
        sessionStorage.removeItem("error");
        sessionStorage.removeItem("errorCategory");
        sessionStorage.removeItem("errorReason");
      };
    }, []);
  
 return (
    <>
       <Head
        style={{ zIndex: "100" }}
        onNextStep={onNextStep}
        showLanguages={false}
        showMobileFlow={false}
        showCountry={false}
        showHelp={false}
        stepperFunc={stepperFunc}
      />

      <div className="parent-container">
        <div className="main">
          <div className="left-section">
            <RenderSvg
              config={config}
              id={"unable_to_process"}
              svgType={"unable_to_process"}
              className="md:w-[300px] md:h-[280px] w-[350px] h-[350px]"
              style={{ marginTop: "3rem" }}
            />
          </div>

          <div
              className="right-section md:items-start items-center"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                gap: 24,
              }}
          >
            <div className="flex flex-col ">      
            <div className="text-[18px] md:text-[24px] font-semibold text-[#000000] text-center md:text-start md:gap-[16px]">
                {errorHandlerTexts?.heading}
                </div>
                <div className="mt-2 text-[12px] md:text-[14px] font-semibold text-[#656565] text-center md:text-start">
                  {errorHandlerTexts.subHeading1}
                </div>
              </div>
            <div className="flex flex-col mt-2 ">
                <div className="flex flex-col md:gap-[16px] gap-3">
                  <div className="flex flex-row gap-[12px] md:w-[100%] items-center">
                    <div>
                      <div
                        className={`px-[8px] py-[8px] rounded-full`}
                      >
                        {(
                          <GoogleIcon
                            iconName="wb_sunny"
                            size={20}
                            style={{ color: color }}
                          />
                        )}
                      </div>
                    </div>
                    <div className="text-[14px] text-[#656565] leading-[20px]">
                      {errorHandlerTexts?.instruction1}
                    </div>
                  </div>
                  <div className="flex flex-row gap-[12px] md:w-[100%] items-center">
                    <div>
                      <div
                        className={`px-[8px] py-[8px] rounded-full`}
                      >
                        <GoogleIcon
                          iconName="center_focus_weak"
                          size={20}
                          style={{ color: color }}
                        />
                      </div>
                    </div>
                    <div
                      className="text-[14px] text-[#656565]"
                      style={{
                        fontWeight: 400,
                        color: "#656565",
                      }}
                    >
                      {errorHandlerTexts?.instruction2}
                      </div>
                  </div>
                  <div className="flex flex-row gap-[12px] md:w-[100%] items-center">
                    <div>
                      <div
                        className={`px-[8px] py-[8px] rounded-full`}
                      >
                        <GoogleIcon
                          iconName="masks"
                          size={20}
                          style={{ color: color }}
                        />
                      </div>
                    </div>
                    <div
                      className="text-[14px] text-[#656565]"
                      style={{
                        fontWeight: 400,
                        color: "#656565",
                      }}
                    >
                      {errorHandlerTexts?.instruction3}
                      </div>
                  </div>
                </div>
            </div>
          
            {/* Try again button */}
            <div className="w-full">
              <div className="flex flex-col w-full justify-center items-center">
                <button
                  className="flex flex-row text-[14px] items-center justify-center gap-4 w-full text-white py-4 px-4 rounded mt-6 md:mt-0"
                  style={{
                    backgroundColor: config?.branding?.accentColor ?? "#1658aa",
                  }}
                  onClick={handleRefresh}
                >
                  {errorHandlerTexts.button}
                  <ArrowPathIcon className="h-5 w-5" />
                </button>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


export default LivenessCheckError;
